const QuizStatusEnum = {
    Inactive: 0,
    Active: 1,
    Started: 2,
    Finished: 3
};
Object.freeze(QuizStatusEnum);
export default QuizStatusEnum;